import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telemedicine-support',
  templateUrl: './telemedicine-support.component.html',
  styleUrls: ['./telemedicine-support.component.css']
})
export class TelemedicineSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
